import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "exhibitor-ticket-alert-threshold" as const;

export type ExhibitorTicketAlertThresholdEventData = {
  exhibitorId: string;
  eventId: string;
  quantityLeft: number;
  alertThreshold: number;
};

export type ExhibitorTicketAlertThresholdEvent = AppEvent<
  typeof eventName,
  ExhibitorTicketAlertThresholdEventData
>;

export const isExhibitorTicketAlertThresholdEvent = (
  event: AnyAppEvent
): event is ExhibitorTicketAlertThresholdEvent => event.name === eventName;

export { eventName as exhibitorTicketAlertThreshold };
